import auth from "../middleware/auth";
import isStaff from "../middleware/isStaff";

export default [
    {
        path: "/teacher-area",
        component: () => {
            return import(
                 "@/projects/teacher_area/App.vue"
            );
        },
        meta: {
            middleware: [auth(false), isStaff]
        },
        children: [
            {
                path: "",
                name: "teacherarea.home",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/teacher_area/views/Home.vue"
                        );
                    }
                }
            },
            {
                path: "get-started",
                name: "teacherarea.getstarted",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/teacher_area/views/GettingStarted.vue"
                        );
                    }
                }
            },
            {
                path: "referral",
                name: "teacherarea.referral",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/teacher_area/views/Referral.vue"
                        );
                    }
                }
            },
            {
                path: "easyfundraising",
                name: "teacherarea.easyfundraising",
                components: {
                    subview: () => {
                        return import(
                            /* webpackChunkName: "ta" */ "@/projects/teacher_area/views/EasyFundraising.vue"
                        );
                    }
                }
            }
        ]
    }
];
